import { ChangeEvent, useEffect } from 'react'
import classNames from 'classnames/bind'
import { Link } from 'react-router'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'

import IconSettings from 'app/components/_Icons/IconSettings'
import subPaymentWPay from 'app/containers/Subs/subPaymentWPay'
import { fetchSections } from 'app/actions/cafeteria/sections'
import { APP_CAFETERIA } from 'app/common/constants/services'
import type { TariffType } from 'app/components/Tariff/Tariff'
import PlainToggle from 'app/common/ui-next/plain-toggle'

import AppFooter from '../AppFooter'
import ElJurFooter from '../ElJurFooter'
import ServTypes from '../ServTypes'
import TariffInfo from '../TariffInfo'
import Icon from './Icon'
import { CustomFooter } from '../CustomFooter/CustomFooter'
import styles from './Application.scss'

const cx = classNames.bind(styles)
// const tarifExtraName = (isOutOfDate: boolean, isExternal: boolean ) => {
//   if (isExternal) {
//     return ''
//   }
// }

type Props = {
  studentId: number
  type?: string
  name: string
  tariffName?: string
  isChosen: boolean
  isOutOfDate?: boolean
  tariff?: TariffType
  service: string
  freeServices: boolean
  showIndicator?: boolean
  appLink: string
  onSwitchChosen: (Object) => void
  settings?: string
  external?: string // eslint-disable-line react/no-unused-prop-types
  subId?: number
  tariffCost?: string
  isPaused?: boolean
  fullName: string
  externalInfo?: string
  notPaid: boolean
  handlePay: (e: ChangeEvent<HTMLElement>) => void
  freeTariff?: boolean
  t: (s: string) => string
  serviceType?: string
  externalLink?: string
  externalIcon?: string
}

const Application = ({
  appLink,
  type = '',
  name,
  tariffName,
  isOutOfDate = false,
  isChosen,
  tariff,
  showIndicator = false,
  settings,
  subId,
  tariffCost,
  freeServices,
  isPaused,
  service,
  studentId,
  fullName,
  externalInfo,
  notPaid,
  handlePay,
  onSwitchChosen,
  freeTariff,
  t,
  serviceType,
  externalLink,
  externalIcon,
}: Props) => {
  const dispatch = useDispatch()
  const loadingCafeSettings = useSelector(
    (state: any) => state.cafeteria.sections.loading,
    shallowEqual,
  )

  useEffect(() => {
    if (service === APP_CAFETERIA && !subId) {
      dispatch(fetchSections(studentId))
    }
  }, [studentId, service, subId, dispatch])
  return (
    <div
      className={cx({
        root: true,
        danger: notPaid || isOutOfDate || isPaused,
        gray: freeTariff,
      })}
    >
      <div className={styles.column}>
        <div className={styles.header}>
          <Icon service={service} />
          <div>
            <div className={styles.type}>{type}</div>
            <h2 className={styles.name}>{name}</h2>
          </div>
          {settings && !loadingCafeSettings && (
            <Link to={settings} className={styles.settings}>
              <IconSettings />
            </Link>
          )}
        </div>

        <div className={styles.filler} />

        {!freeServices && tariff && (
          <TariffInfo
            studentId={studentId}
            service={service}
            subId={subId}
            tariffName={isOutOfDate ? t('old_tariff') : tariffName}
            isFrozen={isPaused}
            tariffCost={tariffCost}
            appName={fullName}
            tariffId={!tariff.tariff_ids ? tariff.id : undefined}
            tariffBundleId={tariff.tariff_ids ? tariff.id : undefined}
          />
        )}

        {!freeServices && tariff && (
          <ServTypes
            className={styles.servTypes}
            title={t('informing_ways')}
            lkProvided={tariff.lk_provided}
            lk={tariff.lk_enabled}
            mobileProvided={tariff.mobile_provided}
            mobile={tariff.mobile_enabled}
            smsProvided={tariff.sms_provided}
            sms={tariff.sms_enabled}
            emailProvided={tariff.email_provided}
            email={tariff.email_enabled}
          />
        )}

        {externalInfo && <div className={styles.externalInfo}>{externalInfo}</div>}

        <div className={styles.chosen}>
          <div className={styles.chosenText}>{t('chosen_one')}</div>
          <PlainToggle
            className={styles.chosenBt}
            value={service}
            checked={isChosen}
            onChange={onSwitchChosen}
            prefix={isChosen ? t('on') : t('off')}
          />

          <div className={styles.chosenComment}>{t('will_be_displayed_in_top_menu')}</div>
        </div>

        {externalInfo && (serviceType === 'eljur' || serviceType === 'custom') ? (
          serviceType === 'eljur' ? (
            <ElJurFooter />
          ) : (
            <CustomFooter externalLink={externalLink} />
          )
        ) : (
          <AppFooter
            showIndicator={showIndicator}
            appLink={appLink}
            subId={subId}
            notPaid={notPaid && !isPaused}
            freeServices={freeServices}
            handlePay={handlePay}
          />
        )}
      </div>
    </div>
  )
}

export default subPaymentWPay(Application)
